import { FieldTypeEnum } from './field-type-enum'
import { TermReq } from './term-req'

export interface ChildFieldInterface {
  groupId: number
  label: string
  type: FieldTypeEnum
  description?: string
  groupWeight?: number
  weight?: number
  parentId?: number
  defaultValue?: object
  rules?: object
  isShow?: boolean
  editable?: boolean
  metadata?: object
  options?: TermReq[]
  name?: string
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class ChildField implements ChildFieldInterface {
  groupId: number
  label: string
  type: FieldTypeEnum
  description?: string
  groupWeight?: number
  weight?: number
  parentId?: number
  defaultValue?: object
  rules?: object
  isShow?: boolean
  editable?: boolean
  metadata?: object
  options?: TermReq[]
  name?: string
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: ChildFieldInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      groupId: _groupId,
      label: _label,
      type: _type,
      description: _description,
      groupWeight: _groupWeight,
      weight: _weight,
      parentId: _parentId,
      defaultValue: _defaultValue,
      rules: _rules,
      isShow: _isShow,
      editable: _editable,
      metadata: _metadata,
      options: _options,
      name: _name,
      id: _id,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.groupId = _groupId
    this.label = _label
    this.type = _type
    this.description = _description
    this.groupWeight = _groupWeight
    this.weight = _weight
    this.parentId = _parentId
    this.defaultValue = _defaultValue
    this.rules = _rules
    this.isShow = _isShow
    this.editable = _editable
    this.metadata = _metadata
    this.options = _options ? _options.map((i) => new TermReq(i)) : _options
    this.name = _name
    this.id = _id
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
